let eventGuid = 0;
let todayStr = new Date().toISOString().replace(/T.*$/, ''); // YYYY-MM-DD of today
let endStr = new Date('2024-03-13').toISOString().replace(/T.*$/, '');

export const INITIAL_EVENTS = [
  {
    id: createEventId(),
    start: '2023-10-01',
    end: '2023-12-31',
    title: 'E Fund Management (HK) Co., Ltd - WWL [1800s]',
    backgroundColor: '#f17300',
    allDay: false,
  },
  // {
  //   id: createEventId(),
  //   start: '2023-11-27',
  //   end: '2024-01-07',
  //   title: '17Live Limited - SCA_SCB',
  // },
  // {
  //   id: createEventId(),
  //   start: '2023-11-27',
  //   end: '2024-01-07',
  //   title: '17Live Limited - SCA_SCB',
  // },
  // {
  //   id: createEventId(),
  //   start: '2023-11-28',
  //   end: '2023-12-26',
  //   title: 'Chessman Entertainment Production (HK) Limited - HKA',
  // },
  // {
  //   id: createEventId(),
  //   start: '2023-11-28',
  //   end: '2023-12-26',
  //   title: 'Chessman Entertainment Production (HK) Limited - HKA',
  // },
  // {
  //   id: createEventId(),
  //   start: '2023-12-03',
  //   end: '2023-12-31',
  //   title: 'Christian Dior Far East Limited - CDP',
  // },
  // {
  //   id: createEventId(),
  //   start: '2023-12-03',
  //   end: '2023-12-31',
  //   title: 'Christian Dior Far East Limited - CDP',
  // },
  // {
  //   id: createEventId(),
  //   start: '2023-12-06',
  //   end: '2023-12-26',
  //   title: 'New World Facilities Management Co. Ltd - HSB [180s]',
  //   backgroundColor: '#f17300',
  // },
  // {
  //   id: createEventId(),
  //   start: '2023-12-07',
  //   end: '2023-12-27',
  //   title: 'New World Facilities Management Co. Ltd - LFG [180s]',
  //   backgroundColor: '#f17300',
  // },
  // {
  //   id: createEventId(),
  //   start: '2023-12-11',
  //   end: '2024-01-07',
  //   title: 'Citibank (Hong Kong) Limited - CAC',
  // },
  // {
  //   id: createEventId(),
  //   start: '2023-12-11',
  //   end: '2024-01-07',
  //   title: 'Citibank (Hong Kong) Limited - CAC',
  // },
  // {
  //   id: createEventId(),
  //   start: '2023-12-11',
  //   end: '2023-12-24',
  //   title: 'Citibank (Hong Kong) Limited - KMB [3600s]',
  //   backgroundColor: '#f17300',
  // },
  // {
  //   id: createEventId(),
  //   start: '2023-12-11',
  //   end: '2024-01-01',
  //   title: 'BVLGARI - ADK',
  // },
  // {
  //   id: createEventId(),
  //   start: '2023-12-11',
  //   end: '2024-01-01',
  //   title: 'BVLGARI - ADK',
  // },
  // {
  //   id: createEventId(),
  //   start: '2023-12-11',
  //   end: '2024-01-07',
  //   title: 'Chessman Entertainment Production (HK) Limited - HHA',
  // },
  // {
  //   id: createEventId(),
  //   start: '2023-12-11',
  //   end: '2024-01-07',
  //   title: 'Chessman Entertainment Production (HK) Limited - HHA',
  // },
  // {
  //   id: createEventId(),
  //   start: '2023-12-15',
  //   end: '2024-01-11',
  //   title: 'Roca Asia Limited - EGC [180s]',
  //   backgroundColor: '#f17300',
  // },
];
// [
//   {
//     id: createEventId(),
//     title: 'Movie: Sumikko Gurashi (180-sec / hour)',
//     start: '2024-03-14',
//     end: '2024-03-27',
//     backgroundColor: randomColor(),
//   },
//   {
//     id: createEventId(),
//     title: 'Branding (180-sec / hour)',
//     start: '2024-03-14',
//     end: '2024-04-03',
//     backgroundColor: randomColor(),
//   },
//   {
//     id: createEventId(),
//     title: 'Rugby 7 (180-sec / hour)',
//     start: '2024-03-14',
//     end: '2024-04-07',
//     backgroundColor: randomColor(),
//   },
// ];

export function createEventId() {
  return String(eventGuid++);
}

function randomColor() {
  var r = Math.floor(Math.random() * 256);
  var g = Math.floor(Math.random() * 256);
  var b = Math.floor(Math.random() * 256);

  return `rgb(${r},${g},${b})`;
}
